import { render, staticRenderFns } from "./DialogFinalizarApuracoes.vue?vue&type=template&id=8deb4c2a"
import script from "./DialogFinalizarApuracoes.vue?vue&type=script&lang=js"
export * from "./DialogFinalizarApuracoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports